import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import styled from 'styled-components';
var cleanButton = "\n  position: relative;\n  border: 0px;\n  padding: 0px;\n  margin: 0px;\n  background-color: #ffffff;\n  font-size: 14px;\n  width: 24px;\n  line-height: 24px;\n  border-radius: 50%;\n  outline: 0;\n  display: flex;\n  align-items: center;\n\tjustify-content: center;\n\t\n\t&:hover {\n\t\tborder-radius: 50px;\n\t\ttext-decoration: none;\n\t}\n";
var activePage = "\n  content: '';\n  display: block;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  position: absolute;\n  z-index: 1;\n  right: 0;\n  bottom: 0;\n  top: 0;\n\tleft: 0;\n";
var disabledAnchor = "\n\t&:disabled,\n\t&[disabled] {\n\t\tpointer-events: none;\n\t\tcursor: default;\n\t}\n";
export var PaginationComponent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 92px;\n"])));
export var PagesList = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0px;\n  padding: 0px 4px;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n  height: 24px;\n\n  button {\n    font-family: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.families.primary;
});
export var PageLinkAnchor = styled.a(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  &:hover {\n\t\tbackground: ", ";\n    color: ", ";\n  }\n  ", "\n"])), cleanButton, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey48;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.grey8;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.grey48;
}, function (_ref5) {
  var isActive = _ref5.isActive,
      theme = _ref5.theme;
  return isActive && "width: 28px;\n\t\t\theight: 28px;\t\n\t\t\tposition: relative;\n\n\t\t\tspan {\n\t\t\tposition: relative;\n\t\t\tz-index: 2;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 16px;\n\t\t\tcolor: white;\n\t\t\t}\n\n\t&:after {\n\t\t".concat(activePage, "\n    background-color: ").concat(theme.colors.secondary.lighten, ";\n\t}");
});
export var Etc = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 24px;\n  width: 24px;\n  height: 24px;\n  text-align: center;\n"])));
export var PrevPageAnchor = styled.a(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  &:hover {\n\t\tbackground: ", ";\n    color: ", ";\n  }\n  height: 24px;\n  margin-right: 16px;\n  border-radius: 50%;\n  text-decoration: none;\n  ", "\n  &:disabled,\n\t&[disabled] {\n\t\tbackground: ", ";\n    i:before {\n\t\t\tbackground-color: ", ";\n\t\t}\n  }\n"])), cleanButton, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.grey48;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey8;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grey48;
}, disabledAnchor, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.grey4;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.grey24;
});
export var NextPageAnchor = styled.a(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  &:hover {\n\t\tbackground: ", ";\n    color: ", ";\n  }\n  height: 24px;\n  margin-left: 16px;\n  border-radius: 50%;\n  text-decoration: none;\n  ", "\n  &:disabled,\n\t&[disabled] {\n\t\tbackground: ", ";\n    i:before {\n\t\t\tbackground-color: ", ";\n\t\t}\n  }\n"])), cleanButton, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.grey48;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.grey8;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.grey48;
}, disabledAnchor, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.grey4;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.grey24;
});